/**
 * System Settings resource - /api/system-settings endpoints
 */
import { getLogger } from '@qwickapps/logging';
const log = getLogger('QwickForge.MiddlewareClient.SystemSettingsResource');
export class SystemSettingsResource {
    http;
    constructor(http) {
        this.http = http;
    }
    /**
     * Get all public system settings
     */
    async getAll() {
        log.debug('Getting system settings');
        try {
            const settings = await this.http.get('/api/system-settings');
            log.debug('System settings retrieved');
            return settings;
        }
        catch (error) {
            log.error('Failed to get system settings', {
                error: error instanceof Error ? error.message : String(error),
            });
            // Return empty object if failed
            return {};
        }
    }
    /**
     * Get a specific system setting
     */
    async get(key) {
        log.debug('Getting system setting', { key });
        try {
            const response = await this.http.get(`/api/system-settings/${key}`);
            return response.value;
        }
        catch (error) {
            if (error.statusCode === 404) {
                log.debug('System setting not found', { key });
                return undefined;
            }
            throw error;
        }
    }
}
//# sourceMappingURL=SystemSettingsResource.js.map